(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-selector"] && !Shopify.designMode) return;
  try {
    
class SamplesSelector extends HTMLElement {
  connectedCallback() {
    this.maxQty = parseInt(this.dataset.maxQty, 10) || 3;
    this.activeQty = parseInt(this.dataset.initialQty, 10) || this.maxQty;

    this.qtyBtns = this.querySelectorAll('.samples-qty__btn');
    this.slots = this.querySelectorAll('.samples-slot');
    this.btn = this.querySelector('.samples-selector__btn');
    this.buyNowBtn = this.querySelector('.samples-selector__buy-now-btn');
    this.priceSummary = this.querySelector('.samples-price-summary');
    this.priceAmount = this.querySelector('.samples-price-summary__amount');
    this.priceOriginal = this.querySelector('.samples-price-original');
    this.priceNote = this.querySelector('.samples-price-note');
    this.discountBadge = this.querySelector('.samples-discount-badge');
    this.cartPopup = this.querySelector('.samples-cart-popup');
    document.body.appendChild(this.cartPopup);
    this.discountQty = parseInt(this.dataset.discountQty, 10) || 3;
    this.discountPct = parseFloat(this.dataset.discountPct) || 10;

    this.qtyBtns.forEach(b => b.addEventListener('click', () => this.onQtyChange(parseInt(b.dataset.qty, 10))));
    this.slots.forEach(slot => {
      slot.querySelector('select')?.addEventListener('change', () => { this.updateButton(); this.updatePrice(); });
    });

    this.btn.addEventListener('click', () => this.onAddToCart());
    this.buyNowBtn.addEventListener('click', () => this.onBuyNow());

    this.cartPopup.querySelector('.samples-cart-popup__close').addEventListener('click', () => this.closeCartPopup());
    this.cartPopup.querySelector('.samples-cart-popup__continue').addEventListener('click', () => this.closeCartPopup());
    document.addEventListener('click', (e) => {
      if (this.cartPopup.classList.contains('is-active') && !e.target.closest('.samples-cart-popup')) {
        this.closeCartPopup();
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeCartPopup(); });
  }

  onQtyChange(qty) {
    this.activeQty = qty;

    this.qtyBtns.forEach(b => {
      const active = parseInt(b.dataset.qty, 10) === qty;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', String(active));
    });

    this.slots.forEach(slot => {
      const slotNum = parseInt(slot.dataset.slot, 10);
      const visible = slotNum <= qty;
      slot.classList.toggle('is-visible', visible);
      if (!visible) slot.querySelector('select').value = '';
    });

    this.updateButton();
    this.updatePrice();
  }

  updateButton() {
    const visibleSlots = [...this.slots].slice(0, this.activeQty);
    const allFilled = visibleSlots.every(slot => {
      const select = slot.querySelector('select');
      return select.value && select.selectedOptions[0]?.dataset.available === 'true';
    });

    this.btn.disabled = !allFilled;
    this.btn.setAttribute('aria-disabled', String(!allFilled));
    this.buyNowBtn.disabled = !allFilled;
    this.buyNowBtn.setAttribute('aria-disabled', String(!allFilled));
  }

  updatePrice() {
    const visibleSlots = [...this.slots].slice(0, this.activeQty);
    let total = 0;
    let anySelected = false;

    visibleSlots.forEach(slot => {
      const select = slot.querySelector('select');
      const opt = select.selectedOptions[0];
      if (select.value && opt?.dataset.price) {
        total += parseInt(opt.dataset.price, 10);
        anySelected = true;
      }
    });

    if (!anySelected) { this.priceSummary.hidden = true; return; }

    this.priceSummary.hidden = false;

    const allFilled = visibleSlots.every(slot => {
      const s = slot.querySelector('select');
      return s.value && s.selectedOptions[0]?.dataset.available === 'true';
    });

    if (this.activeQty >= this.discountQty && allFilled) {
      const discounted = Math.round(total * (1 - this.discountPct / 100));
      this.discountBadge.hidden = false;
      this.priceOriginal.hidden = false;
      this.priceNote.hidden = false;
      this.priceOriginal.textContent = this.formatMoney(total);
      this.priceAmount.textContent = this.formatMoney(discounted);
    } else {
      this.discountBadge.hidden = true;
      this.priceOriginal.hidden = true;
      this.priceNote.hidden = true;
      this.priceAmount.textContent = this.formatMoney(total);
    }
  }

  formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'EGP';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    } catch {
      return (cents / 100).toFixed(2);
    }
  }

  async onAddToCart() {
    if (this.btn.disabled) return;

    const visibleSlots = [...this.slots].slice(0, this.activeQty);
    const items = visibleSlots.map(slot => ({
      id: parseInt(slot.querySelector('select').value, 10),
      quantity: 1,
    }));

    this.btn.classList.add('loading');
    this.btn.setAttribute('aria-disabled', 'true');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Add to cart failed');
      }

      const data = await res.json();

      // Fetch fresh sections AFTER the add is committed. Including `sections` in
      // the POST body can return stale HTML before the cart state is fully
      // written (blank cart items), so request them in a separate GET.
      const sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const sectionsData = await sectionsRes.json();
      const renderData = { ...data, sections: sectionsData };

      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sectionsData['cart-icon-bubble']) {
        const parsed = new DOMParser().parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
        const inner = parsed.querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(renderData);
        cartDrawer.classList.remove('is-empty');
        cartDrawer.open();
      } else {
        // Fallback: theme has no drawer, use the original custom popup
        this.openCartPopup(data.items, sectionsData);
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-selector', productVariantId: items[0]?.id, cartData: data });
      }

      const count = items.length;
      this.btn.textContent = count === 1 ? '✓ Added' : `✓ ${count} samples added`;
      setTimeout(() => { this.btn.textContent = this.btn.dataset.addText; }, 2500);

    } catch (err) {
      console.error('[SamplesSelector]', err);
    } finally {
      this.btn.classList.remove('loading');
      this.btn.setAttribute('aria-disabled', 'false');
    }
  }

  openCartPopup(addedItems, sections) {
    const list = this.cartPopup.querySelector('.samples-cart-popup__items');
    list.innerHTML = addedItems.map(item => {
      const imgSrc = item.image
        ? (item.image.startsWith('//') ? 'https:' + item.image : item.image)
        : null;
      return `
        <li class="samples-cart-popup__item">
          ${imgSrc ? `<img src="${imgSrc}" alt="${item.product_title || item.title}" width="60" height="60">` : ''}
          <span class="samples-cart-popup__item-name">${item.product_title || item.title}</span>
        </li>`;
    }).join('');

    // Update "View cart (N)" text from section
    const viewCartLink = this.cartPopup.querySelector('.samples-cart-popup__view-cart');
    if (sections?.['cart-notification-button']) {
      const parsed = new DOMParser().parseFromString(sections['cart-notification-button'], 'text/html');
      const text = parsed.querySelector('.shopify-section')?.textContent?.trim();
      if (text) viewCartLink.textContent = text;
    }

    const anchor = document.querySelector('.cart-notification-wrapper');
    const header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    const ref = anchor || header;
    if (ref) {
      const rect = ref.getBoundingClientRect();
      this.cartPopup.style.top = (anchor ? rect.top : rect.bottom) + 'px';
    }

    this.cartPopup.hidden = false;
    requestAnimationFrame(() => this.cartPopup.classList.add('is-active'));
  }

  closeCartPopup() {
    this.cartPopup.classList.remove('is-active');
    this.cartPopup.addEventListener('transitionend', () => {
      this.cartPopup.hidden = true;
    }, { once: true });
  }

  async onBuyNow() {
    if (this.buyNowBtn.disabled) return;

    const visibleSlots = [...this.slots].slice(0, this.activeQty);
    const items = visibleSlots.map(slot => ({
      id: parseInt(slot.querySelector('select').value, 10),
      quantity: 1,
    }));

    this.buyNowBtn.classList.add('loading');
    this.buyNowBtn.setAttribute('aria-disabled', 'true');

    try {
      const body = items.length === 1
        ? { id: items[0].id, quantity: 1 }
        : { items };

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Add to cart failed');
      }

      window.location.href = '/checkout';

    } catch (err) {
      console.error('[SamplesSelector]', err);
      this.buyNowBtn.classList.remove('loading');
      this.buyNowBtn.setAttribute('aria-disabled', 'false');
    }
  }

}

if (!customElements.get('samples-selector')) {
  customElements.define('samples-selector', SamplesSelector);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samples-selector"] && !Shopify.designMode) return;
  try {
    
class SamplesSelector extends HTMLElement {
  connectedCallback() {
    this.maxQty = parseInt(this.dataset.maxQty, 10) || 3;
    this.activeQty = 1;

    this.qtyBtns = this.querySelectorAll('.samples-qty__btn');
    this.slots = this.querySelectorAll('.samples-slot');
    this.btn = this.querySelector('.samples-selector__btn');
    this.buyNowBtn = this.querySelector('.samples-selector__buy-now-btn');
    this.priceSummary = this.querySelector('.samples-price-summary');
    this.priceAmount = this.querySelector('.samples-price-summary__amount');
    this.priceOriginal = this.querySelector('.samples-price-original');
    this.priceNote = this.querySelector('.samples-price-note');
    this.discountBadge = this.querySelector('.samples-discount-badge');
    this.cartPopup = this.querySelector('.samples-cart-popup');
    document.body.appendChild(this.cartPopup);
    const parsedDiscountQty = parseInt(this.dataset.discountQty, 10);
    this.discountQty = parsedDiscountQty >= 2 ? parsedDiscountQty : this.maxQty;
    this.discountPct = parseFloat(this.dataset.discountPct) || 15;

    this.qtyBtns.forEach(b => b.addEventListener('click', () => this.onQtyChange(parseInt(b.dataset.qty, 10))));
    this.slots.forEach(slot => {
      slot.querySelector('select')?.addEventListener('change', () => { this.updateButton(); this.updatePrice(); });
    });

    this.btn.addEventListener('click', () => this.onAddToCart());
    this.buyNowBtn.addEventListener('click', () => this.onBuyNow());

    this.cartPopup.querySelector('.samples-cart-popup__close').addEventListener('click', () => this.closeCartPopup());
    this.cartPopup.querySelector('.samples-cart-popup__continue').addEventListener('click', () => this.closeCartPopup());
    document.addEventListener('click', (e) => {
      if (this.cartPopup.classList.contains('is-active') && !e.target.closest('.samples-cart-popup')) {
        this.closeCartPopup();
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeCartPopup(); });
  }

  onQtyChange(qty) {
    this.activeQty = qty;

    this.qtyBtns.forEach(b => {
      const active = parseInt(b.dataset.qty, 10) === qty;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', String(active));
    });

    this.slots.forEach(slot => {
      const slotNum = parseInt(slot.dataset.slot, 10);
      const visible = slotNum <= qty;
      slot.classList.toggle('is-visible', visible);
      if (!visible) slot.querySelector('select').value = '';
    });

    this.discountBadge.classList.toggle('is-visible', qty >= this.discountQty);

    this.updateButton();
    this.updatePrice();
  }

  updateButton() {
    const visibleSlots = [...this.slots].slice(0, this.activeQty);
    const allFilled = visibleSlots.every(slot => {
      const select = slot.querySelector('select');
      return select.value && select.selectedOptions[0]?.dataset.available === 'true';
    });

    this.btn.disabled = !allFilled;
    this.btn.setAttribute('aria-disabled', String(!allFilled));
    this.buyNowBtn.disabled = !allFilled;
    this.buyNowBtn.setAttribute('aria-disabled', String(!allFilled));
  }

  updatePrice() {
    const visibleSlots = [...this.slots].slice(0, this.activeQty);
    let total = 0;
    let anySelected = false;

    visibleSlots.forEach(slot => {
      const select = slot.querySelector('select');
      const opt = select.selectedOptions[0];
      if (select.value && opt?.dataset.price) {
        total += parseInt(opt.dataset.price, 10);
        anySelected = true;
      }
    });

    if (!anySelected) { this.priceSummary.hidden = true; return; }

    this.priceSummary.hidden = false;

    const allFilled = visibleSlots.every(slot => {
      const s = slot.querySelector('select');
      return s.value && s.selectedOptions[0]?.dataset.available === 'true';
    });

    if (this.activeQty >= this.discountQty && allFilled) {
      const discounted = Math.round(total * (1 - this.discountPct / 100));
      this.priceOriginal.hidden = false;
      this.priceNote.hidden = false;
      this.priceOriginal.textContent = this.formatMoney(total);
      this.priceAmount.textContent = this.formatMoney(discounted);
    } else {
      this.priceOriginal.hidden = true;
      this.priceNote.hidden = true;
      this.priceAmount.textContent = this.formatMoney(total);
    }
  }

  formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'EGP';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    } catch {
      return (cents / 100).toFixed(2);
    }
  }

  async onAddToCart() {
    if (this.btn.disabled) return;

    const visibleSlots = [...this.slots].slice(0, this.activeQty);
    const items = visibleSlots.map(slot => ({
      id: parseInt(slot.querySelector('select').value, 10),
      quantity: 1,
    }));

    this.btn.classList.add('loading');
    this.btn.setAttribute('aria-disabled', 'true');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Add to cart failed');
      }

      const data = await res.json();

      // Fetch fresh sections AFTER the add is committed. Including `sections` in
      // the POST body can return stale HTML before the cart state is fully
      // written (blank cart items), so request them in a separate GET.
      const sectionsRes = await fetch('/?sections=cart-drawer,cart-icon-bubble');
      const sectionsData = await sectionsRes.json();
      const renderData = { ...data, sections: sectionsData };

      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sectionsData['cart-icon-bubble']) {
        const parsed = new DOMParser().parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
        const inner = parsed.querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(renderData);
        cartDrawer.classList.remove('is-empty');
        cartDrawer.open();
      } else {
        // Fallback: theme has no drawer, use the original custom popup
        this.openCartPopup(data.items, sectionsData);
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'samples-selector', productVariantId: items[0]?.id, cartData: data });
      }

      const count = items.length;
      this.btn.textContent = count === 1 ? '✓ Added' : `✓ ${count} samples added`;
      setTimeout(() => { this.btn.textContent = this.btn.dataset.addText; }, 2500);

    } catch (err) {
      console.error('[SamplesSelector]', err);
    } finally {
      this.btn.classList.remove('loading');
      this.btn.setAttribute('aria-disabled', 'false');
    }
  }

  openCartPopup(addedItems, sections) {
    const list = this.cartPopup.querySelector('.samples-cart-popup__items');
    list.innerHTML = addedItems.map(item => {
      const imgSrc = item.image
        ? (item.image.startsWith('//') ? 'https:' + item.image : item.image)
        : null;
      return `
        <li class="samples-cart-popup__item">
          ${imgSrc ? `<img src="${imgSrc}" alt="${item.product_title || item.title}" width="60" height="60">` : ''}
          <span class="samples-cart-popup__item-name">${item.product_title || item.title}</span>
        </li>`;
    }).join('');

    // Update "View cart (N)" text from section
    const viewCartLink = this.cartPopup.querySelector('.samples-cart-popup__view-cart');
    if (sections?.['cart-notification-button']) {
      const parsed = new DOMParser().parseFromString(sections['cart-notification-button'], 'text/html');
      const text = parsed.querySelector('.shopify-section')?.textContent?.trim();
      if (text) viewCartLink.textContent = text;
    }

    const anchor = document.querySelector('.cart-notification-wrapper');
    const header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    const ref = anchor || header;
    if (ref) {
      const rect = ref.getBoundingClientRect();
      this.cartPopup.style.top = (anchor ? rect.top : rect.bottom) + 'px';
    }

    this.cartPopup.hidden = false;
    requestAnimationFrame(() => this.cartPopup.classList.add('is-active'));
  }

  closeCartPopup() {
    this.cartPopup.classList.remove('is-active');
    this.cartPopup.addEventListener('transitionend', () => {
      this.cartPopup.hidden = true;
    }, { once: true });
  }

  async onBuyNow() {
    if (this.buyNowBtn.disabled) return;

    const visibleSlots = [...this.slots].slice(0, this.activeQty);
    const items = visibleSlots.map(slot => ({
      id: parseInt(slot.querySelector('select').value, 10),
      quantity: 1,
    }));

    this.buyNowBtn.classList.add('loading');
    this.buyNowBtn.setAttribute('aria-disabled', 'true');

    try {
      const body = items.length === 1
        ? { id: items[0].id, quantity: 1 }
        : { items };

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Add to cart failed');
      }

      window.location.href = '/checkout';

    } catch (err) {
      console.error('[SamplesSelector]', err);
      this.buyNowBtn.classList.remove('loading');
      this.buyNowBtn.setAttribute('aria-disabled', 'false');
    }
  }

}

if (!customElements.get('samples-selector')) {
  customElements.define('samples-selector', SamplesSelector);
}

  } catch(e) { console.error(e); }
})();
})();
